import React, { useState, useEffect, useCallback } from 'react'
import axios from 'axios';

const GetInTouch = () => {
    
    const[formData, setFormData] = useState({});
    const[formIsLoading, setFormIsLoading] = useState(false)
    const [userInfo, setUserInfo] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: ""
    });


    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        setUserInfo((prev) => ({ ...prev, [name]: value }));
    }, []);

    useEffect(()=> {
        const fetchFormData = async() => {
            try {
                const response = await fetch("/api/frontend/get-connect-us");
                const data = await response.json();
                console.log("Form Data: ",data.data[0]);
                setFormData(data.data[0]);
            } catch (error) {
                console.log("An error occurred:", error);
            }
        }
        fetchFormData();
    },[]);

    const handleFormSubmit =(e) => {
        e.preventDefault();
        // console.log("hiii");
        setFormIsLoading(true);
        axios.post("/api/connectus/get-in-touch", {
            fname: userInfo.firstName,
            lname: userInfo.lastName,
            email: userInfo.email,
            'phone/skype': userInfo.phone,
            project_description: userInfo.message
        })
        .then((res)=> { 
            res.data.success && alert("Form Submitted Successfully!!");
            setFormIsLoading(false)
            setUserInfo({
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                message: ""
            })
        })
       .catch(err=> alert("Something Went Wrong..",err))
    }

   

  return (
    <div className="section">
        <div className="container">
            <div className="footer_get_touch_inner grid-70-30">
                <div className="colmun-70 get_form">
                    <div className="get_form_inner">
                        <div className="get_form_inner_text">
                        <h3>Get In Touch</h3>
                        </div>
                        <form onSubmit={handleFormSubmit}>
                        <div className="grid-50-50">
                            <input type="text" name="firstName" placeholder="First Name" value={userInfo.firstName} onChange={handleInputChange} required />
                            <input type="text" name="lastName" placeholder="Last Name" value={userInfo.lastName} onChange={handleInputChange} required />
                            <input type="email" name="email" placeholder="Email" value={userInfo.email} onChange={handleInputChange} required />
                            <input type="tel" name="phone" placeholder="Phone/Skype" value={userInfo.phone} onChange={handleInputChange} required />
                        </div>
                        <div className="grid-full">
                            <textarea name="message" placeholder="About Your Project" value={userInfo.message} onChange={handleInputChange} rows="10" required></textarea>
                            <input type="submit" value={formIsLoading? "Please Wait..." : "Submit"} />
                        </div>
                        </form>
                    </div>
                </div>
                <div className="colmun-30 get_say_form">
                
                    <h5>Let's Connect!</h5>
                    <ul className="get_say_info_sec">
                        <li><i className="fa fa-envelope"></i><a href={`mailto:${formData.email}`} target='_blank'>{formData.email}</a></li>
                        <li><i className="fa-brands fa-whatsapp"></i><a href={`tel:${formData.phoneno}`} target='_blank'>{formData.phoneno}</a></li>
                    </ul>
                    <ul className="get_say_social-icn">
                        <li><a href={`${formData.fb_link}`} target='_blank'><i className="fa-brands fa-facebook-f"></i></a></li>
                        <li><a href={`${formData.insta_link}`} target='_blank'><i className="fa-brands fa-instagram"></i></a></li>
                        <li><a href={`${formData.twitter_link}`} target='_blank'><i class="fa-brands fa-x-twitter"></i></a></li>
                        <li><a href={`${formData.linked_in_link}`} target='_blank'><i className="fa-brands fa-linkedin-in"></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
  )
}

export default GetInTouch;